/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePayJunctionKeyResponse
 */
export interface CreatePayJunctionKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatePayJunctionKeyResponse
     */
    key: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePayJunctionKeyResponse
     */
    created: Date;
}

/**
 * Check if a given object implements the CreatePayJunctionKeyResponse interface.
 */
export function instanceOfCreatePayJunctionKeyResponse(value: object): value is CreatePayJunctionKeyResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function CreatePayJunctionKeyResponseFromJSON(json: any): CreatePayJunctionKeyResponse {
    return CreatePayJunctionKeyResponseFromJSONTyped(json, false);
}

export function CreatePayJunctionKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayJunctionKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'created': (new Date(json['created'])),
    };
}

export function CreatePayJunctionKeyResponseToJSON(json: any): CreatePayJunctionKeyResponse {
    return CreatePayJunctionKeyResponseToJSONTyped(json, false);
}

export function CreatePayJunctionKeyResponseToJSONTyped(value?: CreatePayJunctionKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'created': value['created'].toISOString(),
    };
}

